import { apiGet, apiPost, apiPatch, apiDelete } from './client'

export async function getAllDevices(
  token: string,
  filters?: Record<string, any>,
) {
  const params = new URLSearchParams()
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== '') {
        params.append(key, String(value))
      }
    })
  }
  const qs = params.toString()
  return apiGet(`/admin/devices/all${qs ? `?${qs}` : ''}`, token)
}

export async function createDevice(token: string, data: any) {
  return apiPost('/admin/devices/create', token, data)
}

export async function createCradleDevice(
  token: string,
  data: { deviceUid: string; serialNumber: string },
) {
  return apiPost('/admin/devices/create-cradle', token, data)
}

export async function updateDeviceStatus(
  token: string,
  deviceId: string,
  status: string,
) {
  return apiPatch(`/admin/devices/${deviceId}/status`, token, { status })
}

export async function deleteDevice(token: string, deviceId: string) {
  return apiDelete(`/admin/devices/${deviceId}`, token)
}

export async function updateDeviceCamera(
  token: string,
  deviceId: string,
  data: {
    cameraName?: string | null
    streamType?: 'mjpeg' | 'hls' | 'iframe' | null
    streamUrl?: string | null
    posterUrl?: string | null
  },
) {
  return apiPatch(`/admin/devices/${deviceId}/camera`, token, data)
}

export async function getDeviceCameraStream(token: string, deviceId: string) {
  return apiGet(`/api/v1/devices/${deviceId}/camera-stream`, token)
}
